import { useContext } from 'react';
import { TourSchedulingContext, type TourSchedulingContextType } from './TourSchedulingContext';

export const useTourSchedulingContext = (): TourSchedulingContextType => {
  const context = useContext(TourSchedulingContext);

  if (context === undefined) {
    throw new Error('useTourSchedulingContext must be used within a TourSchedulingProvider');
  }

  return context;
};
